/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Variables = {
  price: number | null;
  type: string;
};
type Phrase = (l: Locale, v: Variables) => string;

export const i18n_purchase_this_content: Phrase = (locale, variables) => {
  if (!variables.price) return '';
  const phrases: { [key: string]: undefined | string } = {
    en: `Purchase this ${variables.type} for $${variables.price}`,
    es: `Compra este ${variables.type} por $${variables.price}`,
  };
  return phrases[locale] || phrases.en || `Purchase this content for access`;
};
